/* eslint-disable*/
import VueStoreService from './VueStoreService';
const InternalMovement = {
    async getMovements(url,store){
        var resp = await VueStoreService.get("internal-detail"+url, store)
        return resp;
    },
    async saveMovements(data,store){
        var resp = await VueStoreService.post("internal-detail",data,store)
        return resp;
    },
    async getMovInternal(mov_id,store){
        var resp = await VueStoreService.get( "internal-detail/"+mov_id,store)
        return resp;
    },
    //INTERN MOVEMENT

    async getInternMovements(url,store){
        var resp = await VueStoreService.get("internal-movements"+url, store)
        return resp;
    },
    async SendMovements(data,store){
        var resp = await VueStoreService.post("internal-movements",data,store)
        return resp;
    },

    async updateProcess(mov_id,data,store){
        var resp = await VueStoreService.patch("internal-detail/"+mov_id,data,store)
        return resp;
    },

    async getMovementObservation(mov_id,store){
        var resp = await VueStoreService.get("internal-detail/observations/"+mov_id,store)
        return resp;
    },

    async getLosts(url,store){
        var resp = await VueStoreService.get("internal-detail/lostDetails"+url, store)
        return resp;
    }
}

export default InternalMovement;